import React, { useState } from 'react';

import loadingGif from '../images/balls.gif';

export default function SearchAddButton({ selected = false, loading = false, onAdd = ()=>{}, className = '', label = 'Add' }) {
	const [pending, setPending] = useState(false);
	const isPending = pending || loading;

	const handleAdd = async () => {
		if(isPending || selected) return;

		setPending(true);
		try {
			await onAdd();
		} catch(error) {
			console.log(error);
		} finally {
			setPending(false);
		}
	};

	if(selected && !isPending) return <div className='search-add-already-selected'>Selected</div>;

	return (
		<div
			className={`search-add-add-btn search-add-add-btn-feedback ${isPending ? 'search-add-add-btn-pending' : ''} ${className}`.trim()}
			onClick={handleAdd}
			aria-busy={isPending}
		>
			<span className={isPending ? 'search-add-add-btn-label-hidden' : ''}>{label}</span>
			{isPending && <img className='search-add-add-btn-loading-gif' src={loadingGif} alt='Adding...' />}
		</div>
	);
}
